import { endPoints, requestType } from "../lib/variable";
import Api from "./index";

export const getJobs = () => {
  return Api(endPoints.getJobs, null, requestType.GET);
};
export const getJobDetails = (params) => {
  return Api(endPoints.getJobDetails, params, requestType.POST);
};
export const getJobId = (id) => {
  return Api(`${endPoints.getJobId}/${id}`, null, requestType.GET);
};
export const getJobDetailsById = (id) => {
  return Api(`${endPoints.getJobById}/${id}`, null, requestType.GET);
};

export const updateJobByAdmin = (id, params) => {
  return Api(`${endPoints.updateJobByAdmin}/${id}`, params, requestType.POST);
};
export const assingJob = (params) => {
  return Api(endPoints.assingJob, params, requestType.POST);
};
export const unAssingJob = (params) => {
  return Api(endPoints.unAssingJob, params, requestType.POST);
};
